import { render, staticRenderFns } from "./Register2.vue?vue&type=template&id=77e2b79d&"
import script from "./Register2.vue?vue&type=script&lang=js&"
export * from "./Register2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports